import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'
import WithholdingTaxesIndexContainer from './WithholdingTaxesIndexContainer'

class WithholdingTaxIndexPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired
    }

    componentDidMount() {
        document.title = 'Withholding Taxes | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                    { path: '/withholding_taxes', name: 'Withholding Taxes' }
                ]}>
                    <ContentLayout>
                        <WithholdingTaxesIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default WithholdingTaxIndexPage
